import styled from 'styled-components';

const ItemServiceStyle = styled.div`
	--paddingBlockText: var(--sp4x) var(--sp3x);
	--blockTextTopP: var(--sp3x);
	--radiusItem: var(--sp3x);
	--sizeImage: 55%;

	height: 100%;
	border-radius: var(--radiusItem);
	border: 1px solid var(--borderSecondaryColor);
	overflow: hidden;
	transition: border-color 0.3s ease-out;

	.inner-wrapper-item {
		.link-item {
			height: 100%;
			display: flex;
			flex-direction: column;

			.wrapper-description {
				height: 100%;
				padding: var(--paddingBlockText);
				padding-top: var(--blockTextTopP);
				transition: var(--trTime) ease-out;
			}
		}
	}

	.image-cont {
		--proportion: var(--sizeImage);

		&:before {
			content: '';
			position: absolute;
			top: 0;
			width: 100%;
			height: 100%;
			z-index: 1;
			background-color: var(--textPrimaryColor);
			opacity: 0.3;
			transition: opacity 0.8s ease-out;
		}
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			&:hover {
				border-color: var(--borderPrimaryColor);

				.wrapper-description {
					background-color: var(--white);
				}

				.image-cont {
					&:before {
						opacity: 0;
					}
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--paddingBlockText: var(--sp3-5x) var(--sp3x);
		--blockTextTopP: var(--sp3x);
		--radiusItem: var(--sp2x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--paddingBlockText: var(--sp3x) var(--sp2x);
		--blockTextTopP: var(--sp2x);
		--radiusItem: var(--sp2x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--paddingBlockText: var(--sp2x) var(--sp2x);
		--blockTextTopP: var(--sp2x);
		--radiusItem: var(--sp1-5x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--paddingBlockText: var(--sp1-5x) var(--sp1-5x);
		--blockTextTopP: var(--sp1x);
		--radiusItem: var(--sp1x);
		--sizeImage: 65%;
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--paddingBlockText: var(--sp2x) var(--sp1x);
		--blockTextTopP: var(--sp1-5x);
		--radiusItem: var(--sp1-5x);
		--sizeImage: 80%;
	}
`;

export default ItemServiceStyle;
